<template>
  <div class="chat-flow-preview">
    <div v-if="!treeData || !treeData.length" class="empty-state">
      Nenhum item de fluxo para exibir.
    </div>

    <v-tree
      v-else
      ref="tree"
      :canDeleteRoot="false"
      :data="normalizedTreeData"
      :draggable="false"
      :halfcheck="true"
      :multiple="false"
      :tpl="tpl"
    />
  </div>
</template>

<script>
import {VTree} from 'vue-tree-halower';
import { getOptionDataFromNodeTitle } from "@/utils";

export default {
  name: 'chat-flow-preview',
  components: {VTree},
  props: {
    treeData: {
      type: Array,
      required: true
    }
  },
  computed: {
    normalizedTreeData() {
      const root = {
        title: 'Fluxo de Conversa',
        expanded: true,
        children: (this.treeData || []).map(node => this.normalizeNode(node))
      };

      return [root];
    }
  },
  methods: {
    getNodeTitleMeta(nodeTitle, parent) {
      if (typeof nodeTitle !== 'string' || nodeTitle.indexOf('|') === -1) {
        return {
          optionNumber: NaN,
          parentId: NaN,
          newNodeTitle: typeof nodeTitle === 'string' ? nodeTitle : ''
        };
      }

      try {
        return getOptionDataFromNodeTitle(nodeTitle, parent);
      } catch (error) {
        return {
          optionNumber: NaN,
          parentId: NaN,
          newNodeTitle: nodeTitle
        };
      }
    },
    normalizeNode(node) {
      const title = node && node.title !== undefined && node.title !== null ? String(node.title) : '(Sem texto)';
      return {
        ...node,
        title: title,
        expanded: true,
        children: (node.children || []).map(child => this.normalizeNode(child))
      };
    },
    tpl(...args) {
      const {0: node, 2: parent} = args;
      let nodeTitle = node.title;

      const imageUrl = node && node.image_url ? node.image_url : null;
      const redirectUrl = node && node.redirect_url ? node.redirect_url : null;
      const mediaUrl = imageUrl || redirectUrl;
      const {optionNumber, parentId, newNodeTitle} = this.getNodeTitleMeta(nodeTitle, parent);

      nodeTitle = newNodeTitle;
      const isEmptyNodeTitle = !nodeTitle || nodeTitle === 'null';
      if (!node.children.length && isNaN(optionNumber) && parentId && node.children[0] && node.children[0].is_close) {
        return (<span domPropsInnerHTML={nodeTitle}></span>)
      }

      return (
        <span>
          {
            mediaUrl ? (() => {
              const url = mediaUrl;
              const fileName = node.document_name || '';

              const getExtension = (fileName, url) => {
                if (fileName) { return fileName.split('.').pop().toLowerCase(); }
                const cleanUrl = url.split('?')[0];
                return cleanUrl.split('.').pop().toLowerCase();
              };

              const extension = getExtension(fileName, url);
              if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'tiff', 'tif', 'svg', 'heic', 'heif', 'ico', 'jfif', 'avif'].includes(extension)) {
                return (
                  <div class="chat-option-image">
                    <img src={url} class="chat-media-img" alt="img"/>
                    { !isEmptyNodeTitle && <span class="image-caption" domPropsInnerHTML={(nodeTitle || '').replace(/\n/g, '<br>')}></span> }
                  </div>
                );
              }

              if (['mp4', 'mkv', 'webm', 'avi', 'mov', 'wmv', 'flv', 'm4v', '3gp', 'mpg', 'mpeg', 'ogv'].includes(extension)) {
                return (
                  <div class="chat-option-image">
                    <video src={url} controls class="chat-media-video"></video>
                    {!isEmptyNodeTitle && <span class="image-caption">{nodeTitle}</span>}
                  </div>
                );
              }

              if (['pdf'].includes(extension)) {
                return (
                  <div class="chat-option-image pdf-style">
                    <div class="pdf-preview">
                      <span class="pdf-icon">📄</span>
                      <div class="pdf-details">
                        <a href={url} target="_blank" class="pdf-link">
                          {fileName || 'Arquivo PDF'}
                        </a>
                        {!isEmptyNodeTitle && (
                            <span class="pdf-caption">{nodeTitle}</span>
                        )}
                      </div>
                    </div>
                  </div>
                );
              }

              if (['xlsx', 'xls', 'xlsm', 'csv', 'tsv', 'ods', 'odt'].includes(extension)) {
                return (
                  <div class="chat-option-image sheet-style">
                    <div class="sheet-preview">
                      <span class="sheet-icon">📊</span>
                      <div class="sheet-details">
                        <a href={url} target="_blank" download class="sheet-link">
                          {fileName || 'Planilha'}
                        </a>
                        {!isEmptyNodeTitle && (
                            <span class="sheet-caption">{nodeTitle}</span>
                        )}
                      </div>
                    </div>
                  </div>
                );
              }

              if (['mp3', 'wav', 'ogg', 'oga', 'm4a', 'aac', 'flac', 'opus', 'weba', 'mid', 'midi', 'aiff', 'aif', 'wma'].includes(extension)) {
                return (
                  <div class="chat-option-image audio-style">
                    <audio controls class="chat-media-audio">
                      <source src={url} type={`audio/${extension}`}/>
                      Seu navegador não suporta o elemento de áudio.
                    </audio>
                    {!isEmptyNodeTitle && <span class="audio-caption">{nodeTitle}</span>}
                  </div>
                );
              }

              return (
                <div class="chat-option-image file-style">
                  <div class="file-preview">
                    <span class="file-icon">📎</span>
                    <div class="file-details">
                      <a href={url} target="_blank" download class="file-link"> {fileName || 'Abrir Arquivo'} </a>
                      {!isEmptyNodeTitle && ( <span class="file-caption">{nodeTitle}</span> )}
                    </div>
                  </div>
                </div>
              );
            })() : (
                <span domPropsInnerHTML={nodeTitle}></span>
            )
          }
        </span>
      )
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/extraComponents/tree.scss";
@import "@/assets/scss/vuexy/apps/chatFlows/media.scss";

.settings-flow-panel {
  border: 3px dotted rgba(0, 0, 0, 0.2);
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);
  border-radius: 10px;
}

.chat-flow-preview {
  max-height: 460px;
  overflow-y: auto;
  padding: 2px 0;
}

.empty-state {
  color: #6b7280;
  font-size: 12px;
}
</style>
